import { render, staticRenderFns } from "./Grade10.vue?vue&type=template&id=621c1ae4"
import script from "./Grade10.vue?vue&type=script&lang=js"
export * from "./Grade10.vue?vue&type=script&lang=js"
import style0 from "@/scss/welcome-landing.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/scss/grade-10-landing.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports